'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/supports-color/browser.js
// module id = 775
// module chunks = 0